import { render, staticRenderFns } from "./ReportGnbDataMenu.vue?vue&type=template&id=76b6283a&"
import script from "./ReportGnbDataMenu.vue?vue&type=script&lang=js&"
export * from "./ReportGnbDataMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports